import { render, staticRenderFns } from "./modalHistory.vue?vue&type=template&id=4f650198&scoped=true&"
import script from "./modalHistory.vue?vue&type=script&lang=js&"
export * from "./modalHistory.vue?vue&type=script&lang=js&"
import style0 from "./modalHistory.vue?vue&type=style&index=0&id=4f650198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f650198",
  null
  
)

export default component.exports